import { render, staticRenderFns } from "./my-item2.vue?vue&type=template&id=3002bc00&scoped=true&"
import script from "./my-item2.vue?vue&type=script&lang=js&"
export * from "./my-item2.vue?vue&type=script&lang=js&"
import style0 from "./my-item2.vue?vue&type=style&index=0&id=3002bc00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3002bc00",
  null
  
)

export default component.exports